import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { QuoteToolLiteStore } from '../../../store';
import { filter, Observable, switchMap, tap } from 'rxjs';
import { AyaCourseService } from '../../../services';
import { AyaCourseSummary } from '../../../types';
import { LoadingService } from '@lx/shared/ui/loading-spinner';
import { QuoteStepFooterComponent } from '../../quote-step-footer/quote-step-footer.component';
import { SkeletonModule } from 'primeng/skeleton';
import { CardContainerComponent, ImageComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { BreakpointObserverService } from '@lx/shared/utils-dom';
import { finalize, map } from 'rxjs/operators';

@Component({
  standalone: true,
  imports: [CommonModule, ConfirmDialogModule, CardContainerComponent, QuoteStepFooterComponent, SkeletonModule, ImageComponent],
  selector: 'lx-aya-quote-step',
  templateUrl: './aya-quote-step.component.html',
  styleUrls: ['./aya-quote-step.component.scss'],
  providers: [ConfirmationService],
})
export class AyaQuoteStepComponent implements OnInit {
  courseSummary$: Observable<AyaCourseSummary> | undefined;

  loadedImage = false;

  skeletonImageHeight$: Observable<string> | undefined;

  private readonly ayaCourseService = inject(AyaCourseService);
  private readonly quoteToolLiteStore = inject(QuoteToolLiteStore);
  private readonly loadingService = inject(LoadingService);
  private readonly breakpointObserver = inject(BreakpointObserverService);

  ngOnInit() {
    this.courseSummary$ = this.quoteToolLiteStore.selectedLanguageAndCourse$.pipe(
      filter((course) => !!course),
      tap(() => this.loadingService.startLoading($localize`Loading course summary...`)),
      switchMap(({ selectedLanguage, selectedCourse }) =>
        this.ayaCourseService.getCourseSummary(selectedCourse?.code, selectedLanguage).pipe(finalize(() => this.loadingService.stopLoading())),
      ),
    );

    this.skeletonImageHeight$ = this.breakpointObserver.isMobile$.pipe(map((mobile) => (mobile ? '12rem' : '22rem')));
  }

  onImageLoaded() {
    this.loadedImage = true;
  }
}
